import { createFileRoute, notFound } from '@tanstack/react-router';
import { ArticlePreviewRefresh } from '~/components/payload/ArticlePreviewRefresh';
import { LearnArticleDetail } from '~/components/sections/LearnArticleDetail';
import { getArticlePreviewByID } from '~/lib/payload';
import readingStylesHref from '~/styles/reading.css?url';

export const Route = createFileRoute('/preview/articles/$id')({
  loader: async ({ params }) => {
    const article = await getArticlePreviewByID({ data: params.id });
    if (!article) throw notFound();
    return { article };
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: `Preview: ${loaderData?.article.title ?? 'Article'} – nsave` },
      { name: 'robots', content: 'noindex,nofollow,noarchive' },
    ],
    links: [{ rel: 'stylesheet', href: readingStylesHref }],
  }),
  component: ArticlePreviewPage,
});

function ArticlePreviewPage() {
  const { article } = Route.useLoaderData();
  return (
    <>
      <ArticlePreviewRefresh />
      <LearnArticleDetail key={article.fullPath} article={article} />
    </>
  );
}
